/*
 * @author: pengjun
 * @date: 2024-12-13
 * @lastEditors: pengjun
 * @lastEditTime: 2025-09-05
 * @description:
 */
import React from 'react';
import { Layout } from 'antd';
import Header from '@/components/Header'
import './index.scss'
import Footer from '@/components/Footer';
import { HashRouter, Route, Switch } from 'react-router-dom'
import Invest from '@/pages/website/invest';
import SettleIn from '@/pages/website/settle-in';
import WebsiteFooter from '@/pages/website/components/WebsiteFooter';
import Qualification from '@/pages/website/qualification';
import Questions from '@/pages/website/questions';

function WebLayout() {
  const { Header: AntHeader, Content } = Layout;

  return (
    <Layout className='website-layout'>
      <Header></Header>
      <Content>

        <HashRouter>
          <Switch>
            <Route path="/website/invest" component={Invest}></Route>
            <Route path="/website/settle-in" component={SettleIn}></Route>
            <Route path="/website/qualification" component={Qualification}></Route>
            <Route path="/website/questions" component={Questions}></Route>
          </Switch>
        </HashRouter>
        <Footer></Footer>
      </Content>
      <WebsiteFooter />
    </Layout>
  );
}

export default WebLayout;
